import { cn } from "@/lib/utils";

interface HourRailProps {
  hour: number;
  className?: string;
}

export function HourRail({ hour, className }: HourRailProps) {
  const label = `${hour.toString().padStart(2, "0")}:00`;
  return (
    <div
      className={cn("flex items-center gap-2 px-3 my-2 select-none", className)}
      aria-hidden
    >
      <div className="h-px flex-1 bg-biz-border" />
      <span className="font-mono-num text-[11px] font-semibold text-biz-foreground-subtle tracking-wider">
        {label}
      </span>
      <div className="h-px flex-1 bg-biz-border" />
    </div>
  );
}
